import styled from 'styled-components'
import { Product as OriginalProduct } from '../PreviewProduct/theme'

export const Set = styled.div`
  width: ${props => (props.w ? `${props.w}px` : 'auto')};
  height: ${props => (props.h ? `${props.h}px` : 'auto')};
  overflow: hidden;

  position: relative;
  box-shadow: ${props => (props.isSelected ? `0px 0px 15px ${props.theme.colors.alternativeHover}` : 'none')};
`

export const Product = styled(OriginalProduct)`
  position: absolute;
  top: ${props => props.y}px;
  left: ${props => props.x}px;
`



// WEBPACK FOOTER //
// ./src/components/PreviewSet/theme.js